(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('.amc-collection:not([data-amc-ready])').forEach(section => {
      section.dataset.amcReady = 'true';
      const dialog = section.querySelector('dialog');
      const opener = section.querySelector('[data-amc-open]');
      const close = () => { dialog.close(); opener.focus({preventScroll:true}); };
      opener.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-amc-close]').addEventListener('click', close);
      dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) close(); });
      dialog.querySelector('form').addEventListener('submit', () => {
        dialog.querySelectorAll('input[type=number]').forEach(input => { if (!input.value) input.disabled = true; });
      });
      section.querySelectorAll('.amc-editorial video').forEach(video => {
        const tile = video.closest('.amc-editorial');
        const button = tile.querySelector('.amc-video-toggle');
        let visible = false;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.autoplay = !reduced.matches;
        const update = () => {
          if (!button) return;
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.setAttribute('aria-pressed', String(!video.paused));
        };
        const play = () => {
          video.muted = true;
          const pending = video.play();
          pending?.catch(() => { update(); });
        };
        const autoPlay = () => {
          if (visible && !document.hidden && !reduced.matches && video.dataset.userPaused !== 'true') play();
        };
        button?.addEventListener('click', () => {
          if (video.paused) {
            video.dataset.userPaused = 'false';
            if (video.error) video.load();
            play();
          } else {
            video.dataset.userPaused = 'true';
            video.pause();
          }
        });
        video.addEventListener('playing', () => { tile.classList.add('is-video-ready'); update(); });
        video.addEventListener('pause', update);
        video.addEventListener('error', () => { tile.classList.remove('is-video-ready'); update(); });
        video.addEventListener('loadeddata', autoPlay);
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            visible = entries[0].isIntersecting;
            if (visible) autoPlay(); else video.pause();
          }, {threshold:0.01});
          observer.observe(video);
        } else {
          visible = true;
          autoPlay();
        }
        document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else autoPlay(); });
        window.addEventListener('pageshow', autoPlay);
        update();
      });
    });
    root.querySelectorAll('[data-amc-gallery]:not([data-amc-ready])').forEach(gallery => {
      gallery.dataset.amcReady = 'true';
      const section = gallery.closest('.amc-world');
      const previous = section.querySelector('[data-amc-gallery-prev]');
      const next = section.querySelector('[data-amc-gallery-next]');
      const sync = () => {
        previous.disabled = gallery.scrollLeft < 2;
        next.disabled = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2;
      };
      const move = direction => {
        const item = gallery.querySelector('.amc-gallery__item');
        gallery.scrollBy({left:direction*(item.getBoundingClientRect().width+2),behavior:reduced.matches?'instant':'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      gallery.addEventListener('scroll', sync, {passive:true});
      gallery.addEventListener('keydown', event => {
        if (event.target===gallery && ['ArrowLeft','ArrowRight'].includes(event.key)) {
          event.preventDefault(); move(event.key==='ArrowRight'?1:-1);
        }
      });
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(gallery);
      sync();
    });
    root.querySelectorAll('[data-amc-reviews]:not([data-amc-ready])').forEach(section => {
      section.dataset.amcReady='true';
      const slides=[...section.querySelectorAll('figure')];
      const buttons=[...section.querySelectorAll('[data-amc-review]')];
      buttons.forEach((button,index)=>button.addEventListener('click',()=>{
        slides.forEach((slide,i)=>slide.hidden=i!==index);
        buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
        if(!reduced.matches) slides[index].animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'ease-out'});
      }));
    });
    root.querySelectorAll('.amc-faq details:not([data-amc-ready])').forEach(details=>{
      details.dataset.amcReady='true';let animation=null,closing=false;
      details.querySelector('summary').addEventListener('click',event=>{
        event.preventDefault();
        const start=details.getBoundingClientRect().height;
        const shouldOpen=!details.open || closing;
        if(animation)animation.cancel();
        if(reduced.matches){details.open=shouldOpen;return;}
        closing=!shouldOpen;details.style.overflow='hidden';
        let end;
        if(shouldOpen){details.open=true;details.style.height='auto';end=details.getBoundingClientRect().height;}
        else end=details.querySelector('summary').getBoundingClientRect().height+1;
        animation=details.animate([{height:start+'px'},{height:end+'px'}],{duration:260,easing:'cubic-bezier(.2,.6,.3,1)'});
        animation.onfinish=()=>{details.open=shouldOpen;details.style.height='';details.style.overflow='';animation=null;closing=false;};
      });
    });
  };
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
